module.exports = __webpack_public_path__ + "img/nanzhanshi.b7fe283b.png";